import { network } from 'services/network';

export const getTopRecommendationChanges = (params) => {
    const payload = {
        compareVersionId: params.compareVersionId,
        contractId: params.contractId,
        latestVersionId: params.latestVersionId,
        projectId: params.projectId,
    };

    return network.post('api/bo/getTopRecommendationChanges', payload).then((response) => {
        return response.data;
    });
};
